<template>
    <li class="dropdown dropdown-extended dropdown-inbox fade-in" id="header_inbox_bar">
        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown"
            data-close-others="true" title="Menu de contact">
            <i class="icon-envelope-open"></i>
            <span class="badge badge-default" v-if="items.length != 0">
                {{ items.length }}
            </span>
        </a>
        <ul class="dropdown-menu dropD fade-in">
            <li>
                <a href="/contact" class="btn default green-stripe">
                    <span class="bold uppercase">Consulter mes contacts</span>
                </a>
            </li>
            <li>
                <ul class="dropdown-menu-list scroller" style="height: 25vh;" data-handle-color="#637283">
                    <li v-for="item in items">
                        <a :href="'/contact/edit/' + item.contact.id" class="btn">
                           <!-- <p style="font-style: italic;">{{item.user.lastName}}&nbsp;{{item.user.name}}</p>-->
                            <span>{{item.contact.title}} </span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>

<script>
export default {

  name: 'Contact',
async mounted() {
    this.getContacts().then((res) => {
        this.items = res
    })  
  },
  data () {
    return {
        'items': []
    }
  },
  methods: {
    async getContacts() {
        const res = await axios.get('/contact/get')
        return await res.data
    }
  }
};
</script>

<style lang="css" scoped>
</style>
